import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";

/**
 * Standardized "opens in new window" external-link icon. The inline-block wrapper
 * keeps the icon (and its single leading space) out of the link's text-decoration,
 * so only the label text is underlined — never the space or the glyph. Decorative
 * only (aria-hidden); pair it with visible link text and an "(opens in new window)"
 * sr-only note for assistive tech.
 */
export default function ExternalLinkIcon({ className }) {
  return (
    <span className={`inline-block no-underline ${className}`.trim()} aria-hidden="true">
      &nbsp;<FontAwesomeIcon icon={faExternalLink} />
    </span>
  );
}

ExternalLinkIcon.propTypes = {
  className: PropTypes.string,
};

ExternalLinkIcon.defaultProps = {
  className: "",
};
